import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 35px 0 15px;

  @media (min-width: 768px) {
    padding: 70px 0 30px;
  }

  h1 {
    text-align: center;
    font-size: 21px;
    line-height: 17px;
    color: #294f79;
    font-weight: 500;
    margin-bottom: 40px;

    @media (min-width: 768px) {
      font-size: 32px;
      line-height: 34px;
      margin-bottom: 65px;
    }
  }

  h2 {
    font-size: 16px;
    line-height: 24px;
    color: #294f79;
    font-weight: 500;
    margin-bottom: 25px;

    @media (min-width: 768px) {
      font-size: 22px;
      line-height: 30px;
      margin-bottom: 45px;
    }
  }

  h3 {
    font-size: 15px;
    line-height: 22px;
    color: #294f79;
    font-weight: 500;
    margin-bottom: 25px;

    @media (min-width: 768px) {
      font-size: 20px;
      line-height: 28px;
      margin-bottom: 45px;
    }
  }

  p,
  li {
    font-size: 13px;
    line-height: 22px;
    margin-bottom: 30px;

    @media (min-width: 768px) {
      font-size: 16px;
      line-height: 28px;
      margin-bottom: 40px;
    }
  }
`;

const Container = styled.div`
  margin: 0 auto;
  padding: 0 18px;
  max-width: 1140px;
`;

export { Wrapper, Container };
